// extracted by mini-css-extract-plugin
export default {"container":"U8qo8F","scrollableList":"c8Ss4E","event":"vQwVG5","title":"XYxSDb","info":"TQDzRz","time":"ncSGbz"};